export enum ContactPersonPermissions {
  ContactPerson = 'contact-person',
}
